/**
 * Created by Rodrigo Quesada on 15/12/16.
 */
import {NgModule} from '@angular/core';
import {FileInputComponent} from './file-input.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from '@angular/common';

@NgModule({
    imports: [CommonModule, NgbModule],
    declarations: [FileInputComponent],
    exports: [FileInputComponent]
})
export class FileInputModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/file/file-input.module.ts